exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-wrapper-attendee .addFirst {\n  display: none !important; }\n\n.action-wrapper-attendee .removeFirst {\n  display: inherit !important; }\n\n.action-wrapper-attendee:last-child .addFirst {\n  display: inherit !important; }\n\n.action-wrapper-attendee:last-child .removeFirst {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/company-attendees/company-attendees.component.scss
// module id = ../../../../../src/app/crm/company-attendees/company-attendees.component.scss
// module chunks = main